module.exports = __webpack_public_path__ + "media/images/dammy_thumb-36f34b1a5860305ef7a6a21650a96f08.png";